import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Event Managers", -1)
const _hoisted_2 = { class: "subheader" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "event_mngr_email" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", { class: "ion-margin" }, "New Event Manager", -1)

import {
  trash,
  personCircleOutline,
  personAddSharp,
  close,
  save,
} from "ionicons/icons";
import {
  IonLabel,
  IonItem,
  IonIcon,
  IonAlert,
  IonButton,
  IonList,
  IonModal,
  IonInput,
  IonRow,
  IonGrid,
  IonCol,
  IonLoading,
  IonToggle,
} from "@ionic/vue";
import { useUserStore } from "@/stores/user";
import { useContextStore } from "@/stores/context";
import { usePlansStore } from "@/stores/plans";

import { onMounted, reactive } from "vue";
import {
  getEventManagers,
  addEventManager,
  deleteEventManager,
} from "@/api/events";
import { createUser, fetchUserByEmail } from "@/api/users";
import { getSubscribedPlans } from "@/api/plans";
import { IClientPaymentPlanParams } from "@/models/plan";
import { useToasters } from "@/composition/toasters";
import router from "@/router";
import { event as gtag_event } from "vue-gtag";


export default /*#__PURE__*/_defineComponent({
  __name: 'ManageTeam',
  setup(__props) {

const toasters = useToasters();
const userStore = useUserStore();
const contextStore = useContextStore();
const plansStore = usePlansStore();

onMounted(() => {
  userStore.getUserPermissions();
  fetchEventManagers();
  fetchCurrentPlan();
});

const state = reactive({
  loading: false,
  managers: [],
  alertEventManager: false,
  currentEventMngrEdition: 0,
  currentClientAccountEdition: 0,
  modalForm: false,
  user_form: {
    id: 0,
    name: "",
    email: "",
    password: "",
    event: 0,
  },
  event_manager_form: {
    user_account: 0,
    event: 0,
    name: "",
  },
  userNeedToBeCreated: false,
  toggleNewUser: false,
  subscribed_plans: Array<IClientPaymentPlanParams>,
  current_plan: {},
});

const fetchEventManagers = () => {
  state.loading = true;
  getEventManagers(contextStore.event.id).then((response) => {
    state.managers = response.data.results;
    state.loading = false;
  });
};

const fetchCurrentPlan = async () => {
  await plansStore.fetch({ reset: true, page_size: 10 });
  // state.current_plan = plansStore.results[0];

  const plan = await getSubscribedPlans();
  state.subscribed_plans = plan.data.results;

  let current_plan_id = 0;

  state.subscribed_plans.forEach((element: any) => {
    if (element.subscription_status === "active") {
      current_plan_id = element.payment_plan;
      return;
    }
  });

  // Get plan information
  const current_plan = await plansStore.fetchPlan(current_plan_id);
  state.current_plan = current_plan.result;
};

const openDialogDelete = (
  event_manager_id: number,
  client_account_id: number
) => {
  state.alertEventManager = true;
  state.currentEventMngrEdition = event_manager_id;
  state.currentClientAccountEdition = client_account_id;
};

const deleteButtons = [
  {
    text: "Cancel",
    role: "cancel",
    cssClass: "alert-button-cancel",
    handler: () => {
      state.alertEventManager = false;
    },
  },
  {
    text: " OK ",
    role: "confirm",
    cssClass: "alert-button-confirm",
    handler: () => {
      state.alertEventManager = false;
      deleteEventManager(
        state.currentEventMngrEdition,
        contextStore.event.id
      ).then(() => {
        toasters.addSuccess("Event manager deleted successfully.");
        fetchEventManagers();
      });
    },
  },
];

const submit = () => {
  state.user_form.event = contextStore.event.id;
  state.event_manager_form.event = contextStore.event.id;
  state.event_manager_form.name = state.user_form.name;

  // Create a new beamian user if user doesn't exists
  if (state.user_form.email && state.userNeedToBeCreated) {
    createNewEventManagerUser();
  } else {
    // Proceed with the event manager invite
    addEventManager(state.event_manager_form).then(() => {
      state.loading = false;
      state.modalForm = false;
      router.push(`/event/${contextStore.event.id}/team-management`);
      toasters.addSuccess("Event manager invited succesfully.");
      gtag_event("event_manager_added", {
        category: "check-in app",
        label: "Event manager added",
        description: `${plansStore.currentPlan.name}`,
      });
      fetchEventManagers();

      if (
        state.managers.length ===
        plansStore.currentPlan.check_in_max_event_managers
      ) {
        gtag_event("limits_achieved", {
          category: "check-in app",
          label: "Limits achieved while trying to add a event manager",
          description: `${plansStore.currentPlan.name}`,
        });
      }
    });
  }
};

const createNewEventManagerUser = () => {
  if (
    state.user_form.email &&
    state.user_form.name &&
    state.user_form.password &&
    state.user_form.event
  ) {
    state.loading = true;
    createUser(state.user_form).then((response) => {
      state.event_manager_form.user_account = response.data.id;
      state.event_manager_form.name = response.data.name;

      // Proceed with the event manager invite
      addEventManager(state.event_manager_form)
        .then(() => {
          state.loading = false;
          state.modalForm = false;
          router.push(`/event/${contextStore.event.id}/team-management`);
          toasters.addSuccess("Event manager invited succesfully.");
          fetchEventManagers();
        })
        .catch(() => {
          toasters.addError("Failed to invite the user.");
        });
    });
  }
};

const searchForUserEmail = () => {
  const user_is_existing_manager = checkIfUserIsEventManager(
    state.user_form.email
  );

  if (user_is_existing_manager) {
    toasters.addWarning(`The user already is a event manager of this event.`);
  } else {
    state.loading = true;
    fetchUserByEmail(state.user_form.email).then((response) => {
      if (response.data.results.length) {
        const existing_user = response.data.results[0];
        state.event_manager_form.user_account = existing_user.id;
        submit();
      } else {
        state.userNeedToBeCreated = true;
      }
      state.loading = false;
    });
  }
};

const checkIfUserIsEventManager = (email: string) => {
  const manager_exists = state.managers.filter(
    (mngr: object) => mngr.email === email
  );
  return manager_exists.length ? true : false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(IonItem), { class: "header" }, {
      default: _withCtx(() => [
        _createVNode(_unref(IonLabel), null, {
          default: _withCtx(() => [
            _hoisted_1,
            _createElementVNode("p", _hoisted_2, [
              _createElementVNode("b", null, _toDisplayString(_unref(contextStore).event.name), 1)
            ]),
            (
            state.managers && _unref(plansStore).currentPlan.check_in_max_event_managers
          )
              ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(state.managers.length) + " of " + _toDisplayString(_unref(plansStore).currentPlan.check_in_max_event_managers) + " Event Managers ", 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        (_unref(userStore).userIsAdmin)
          ? (_openBlock(), _createBlock(_unref(IonButton), {
              key: 0,
              fill: "clear",
              disabled: 
          state.managers.length >=
          _unref(plansStore).currentPlan.check_in_max_event_managers
        ,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (state.modalForm = true))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonIcon), {
                  icon: _unref(personAddSharp),
                  size: "small",
                  slot: "end",
                  color: "primary"
                }, null, 8, ["icon"])
              ]),
              _: 1
            }, 8, ["disabled"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.managers, (mngr, idx) => {
      return (_openBlock(), _createBlock(_unref(IonItem), { key: idx }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonIcon), {
            class: "mngr_icon",
            icon: _unref(personCircleOutline)
          }, null, 8, ["icon"]),
          _createVNode(_unref(IonLabel), null, {
            default: _withCtx(() => [
              _createElementVNode("h6", null, _toDisplayString(mngr.name), 1),
              _createElementVNode("p", _hoisted_4, _toDisplayString(mngr.email), 1),
              (_unref(userStore).me.id === mngr.user_account && _unref(userStore).userIsAdmin)
                ? (_openBlock(), _createBlock(_unref(IonButton), {
                    key: 0,
                    class: "default_manager",
                    size: "small",
                    color: "primary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("DEFAULT")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1024),
          (_unref(userStore).me.id !== mngr.user_account && _unref(userStore).userIsAdmin)
            ? (_openBlock(), _createBlock(_unref(IonButton), {
                key: 0,
                fill: "clear",
                onClick: ($event: any) => (openDialogDelete(mngr.id, mngr.user_account))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonIcon), {
                    icon: _unref(trash),
                    size: "small",
                    slot: "end",
                    color: "danger"
                  }, null, 8, ["icon"])
                ]),
                _: 2
              }, 1032, ["onClick"]))
            : _createCommentVNode("", true),
          _createVNode(_unref(IonAlert), {
            isOpen: state.alertEventManager,
            buttons: deleteButtons,
            header: "Are you sure?",
            message: "This will permanently delete this event manager.",
            onWillDismiss: _cache[1] || (_cache[1] = ($event: any) => (state.alertEventManager = false))
          }, null, 8, ["isOpen"])
        ]),
        _: 2
      }, 1024))
    }), 128)),
    _createVNode(_unref(IonModal), {
      id: "modal-form",
      "is-open": state.modalForm,
      onWillDismiss: _cache[7] || (_cache[7] = ($event: any) => {
        state.modalForm = false;
        state.user_form.email = '';
      }),
      ref: "modal"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _hoisted_5,
          _createVNode(_unref(IonList), { lines: "none" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonItem), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonLabel), { position: "stacked" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Email")
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonInput), {
                    placeholder: "john.doe@gmail.com",
                    modelValue: state.user_form.email,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((state.user_form.email) = $event)),
                    disabled: state.userNeedToBeCreated
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }),
              (state.userNeedToBeCreated)
                ? (_openBlock(), _createBlock(_unref(IonItem), { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), { position: "stacked" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Name")
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonInput), {
                        placeholder: "John Doe",
                        modelValue: state.user_form.name,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((state.user_form.name) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (state.userNeedToBeCreated)
                ? (_openBlock(), _createBlock(_unref(IonItem), { key: 1 }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), { position: "stacked" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Password")
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonInput), {
                        placeholder: "••••••",
                        type: "password",
                        modelValue: state.user_form.password,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((state.user_form.password) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createElementVNode("div", null, [
            _createElementVNode("section", null, [
              _createVNode(_unref(IonGrid), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonRow), { class: "ion-margin-top action_buttons" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonCol), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonButton), {
                            expand: "block",
                            color: "light",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (state.modalForm = false))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonIcon), {
                                slot: "start",
                                icon: _unref(close)
                              }, null, 8, ["icon"]),
                              _createTextVNode(" CANCEL ")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonCol), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonButton), {
                            expand: "block",
                            color: "success",
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (
                      state.userNeedToBeCreated ? submit() : searchForUserEmail()
                    ))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonIcon), {
                                slot: "end",
                                icon: _unref(save)
                              }, null, 8, ["icon"]),
                              _createTextVNode(" SAVE ")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _createVNode(_unref(IonLoading), {
          "is-open": state.loading,
          message: "Please wait..."
        }, null, 8, ["is-open"])
      ]),
      _: 1
    }, 8, ["is-open"])
  ]))
}
}

})